/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

export interface TextProps {
  children?: React.ReactNode;
  primary?: boolean;
  error?: boolean;
  gutterTop?: boolean;
  gutterBottom?: boolean;
  muted?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  weight?: 'bold' | 'regular';
  width?: number | string;
  style?: React.CSSProperties;
}

export interface TextWithLegendProps {
  children?: React.ReactNode;
  legend?: string;
}

const StyledText = styled.span<TextProps>`
  font-family: Lato;
  font-size: ${({ size }) => {
    switch (size) {
      case 'xs':
        return 10;
      case 'sm':
        return 12;
      case 'lg':
        return 16;
      case 'md':
      default:
        return 14;
    }
  }}px;
  line-height: 1;
  color: ${({ primary, error, muted }) => {
    if (primary) return '#007B5F';
    if (error) return '#ef3340';
    if (muted) return '#999';
    return '#333';
  }};
  font-weight: ${({ weight }) => {
    if (weight === 'bold') return '600';
    return 'normal';
  }};
  ${({ gutterTop }) => (gutterTop ? 'margin-top: 2em;' : '')}
  ${({ gutterBottom }) => (gutterBottom ? 'margin-bottom: 1em;' : '')}
  ${({ width }) =>
    width ? `width: ${typeof width === 'number' ? `${width}px` : width};` : ''}
`;

const TextWithLegendContainer = styled.div<TextWithLegendProps>`
  && > span {
    display: block;

    &:first-child {
      line-height: 2.8;
    }
  }
`;

export const Text: React.FC<TextProps> = (props): JSX.Element => {
  return <StyledText {...props} />;
};

export const TextWithLegend: React.FC<TextWithLegendProps> = ({
  legend,
  children,
}): JSX.Element => {
  return (
    <TextWithLegendContainer>
      <StyledText size="sm" muted>
        {legend}
      </StyledText>
      <StyledText size="lg" weight="bold">
        {children}
      </StyledText>
    </TextWithLegendContainer>
  );
};

export const FormGroupsLegend = styled(Text).attrs({
  gutterTop: true,
  gutterBottom: true,
  weight: 'bold',
})`
  && {
    display: inline-block;
    margin-bottom: 40px;
    text-decoration: underline;
  }
`;

Text.defaultProps = {
  weight: 'regular',
};
